import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useField, useFormikContext } from 'formik';
import { capitalizeFirstLetter, fieldName } from '../../../../../utils';
import Icon, { IconName } from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import ItemListPickerInput from '../../../../common/Form/Fields/ItemListPicker';
import RadioCardsInput from '../../../../common/Form/Fields/RadioCardsInput';
import { StyledField } from '../../../../common/Form/Fields/SelectInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import { DashboardContext } from '../../DashboardContext';
interface SelectDestinationTypeProps {
  prefix: string;
  destination_radio_cards?: boolean;
}
export function SelectDestinationType(t0) {
  const $ = _c(29);
  const {
    prefix,
    destination_radio_cards: t1
  } = t0;
  const destination_radio_cards = t1 === undefined ? false : t1;
  const {
    destination_types
  } = useContext(DashboardContext);
  const {
    submitCount
  } = useFormikContext();
  let t2;
  if ($[0] !== prefix) {
    t2 = fieldName("type", prefix);
    $[0] = prefix;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [, t3] = useField(t2);
  const {
    error,
    touched
  } = t3;
  const has_error = (touched || submitCount > 0) && !!error;
  if (!destination_types) {
    return null;
  }
  if (destination_radio_cards) {
    let T0;
    let t4;
    let t5;
    if ($[2] !== destination_types || $[3] !== prefix) {
      const type_entries = Object.entries(destination_types);
      const ordered_entries = [...type_entries].sort(_temp);
      T0 = RadioCardsInput;
      if ($[7] !== prefix) {
        t4 = fieldName("type", prefix);
        $[7] = prefix;
        $[8] = t4;
      } else {
        t4 = $[8];
      }
      t5 = ordered_entries.map(_temp2);
      $[2] = destination_types;
      $[3] = prefix;
      $[4] = T0;
      $[5] = t4;
      $[6] = t5;
    } else {
      T0 = $[4];
      t4 = $[5];
      t5 = $[6];
    }
    let t6;
    if ($[9] !== T0 || $[10] !== t4 || $[11] !== t5) {
      t6 = <T0 name={t4} options={t5} />;
      $[9] = T0;
      $[10] = t4;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      justify: "space-between",
      align: "center"
    };
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Div flex={t4}><label><Text size="xs" semi={true} muted={true}>Destination Type<Text danger={true} as="span">*</Text></Text></label></Div>;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== prefix) {
    t6 = fieldName("type", prefix);
    $[15] = prefix;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== destination_types) {
    t8 = search_term_0 => Promise.resolve(Object.entries(destination_types).filter(t9 => {
      const [, config_0] = t9;
      if (search_term_0 && !config_0.label.toLowerCase().includes(search_term_0.toLowerCase())) {
        return false;
      }
      return true;
    }).map(_temp4));
    $[18] = destination_types;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <ItemListPickerInput name={t6} categories={t7} outline={true} search={false} show_category_badge={false} getItemsKey={_temp3} getItems={t8} />;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== error || $[24] !== has_error) {
    t10 = has_error ? <Text m={{
      t: 1,
      b: 0
    }} size="xs" as="p" danger={true}><Icon icon="info" left={1} />{error}</Text> : <Text m={{
      t: 1,
      b: 0
    }} size="xs" as="p" muted={true}><Icon icon="info" left={1} />Represents the consumer of your HTTP requests.</Text>;
    $[23] = error;
    $[24] = has_error;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t9) {
    t11 = <StyledField large={true} block={true}>{t5}{t9}{t10}</StyledField>;
    $[26] = t10;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}
function _temp4(t0) {
  const [key_0, config_1] = t0;
  return {
    id: key_0,
    icon: (config_1.icon || "destination" as const) as IconName,
    label: config_1.label,
    description: config_1.description,
    category: capitalizeFirstLetter(config_1.category)
  };
}
function _temp3(search_term, category) {
  return `destination-types-${search_term}-${category}`;
}
function _temp2(t0) {
  const [key, config] = t0;
  return {
    value: key,
    label: config.label,
    description: config.description
  };
}
function _temp(a, b) {
  if (a[0] === "MOCK_API") {
    return -1;
  }
  if (b[0] === "MOCK_API") {
    return 1;
  }
  return 0;
}